var _rect, _rect2, _path, _circle, _circle2, _circle3, _path2, _path3, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTdMonogramTrailHorizontal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 75,
    viewBox: "0 0 280 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14,
    width: 50,
    height: 5,
    fill: "#84cc16",
    opacity: 0.25,
    rx: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 14,
    width: 5,
    height: 28,
    fill: "#84cc16",
    opacity: 0.35,
    rx: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 37 42 L 37 68 L 52 68 C 62 68 70 61 70 55 C 70 49 62 42 52 42 Z",
    fill: "#84cc16",
    opacity: 0.15
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 55,
    r: 14,
    fill: "#84cc16"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 55,
    r: 10.5,
    fill: "#84cc16",
    opacity: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 55,
    r: 7.5,
    fill: "#84cc16",
    opacity: 0.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 60 47 Q 66 40 75 36",
    stroke: "#84cc16",
    strokeWidth: 2.2,
    fill: "none",
    opacity: 0.35,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 61 63 Q 67 70 75 74",
    stroke: "#84cc16",
    strokeWidth: 2.2,
    fill: "none",
    opacity: 0.25,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 50,
    fontFamily: "Inter, system-ui, sans-serif",
    fontSize: 24,
    fontWeight: 700,
    fill: "#27272a",
    letterSpacing: "-0.02em"
  }, "TENNIS DIARY")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTdMonogramTrailHorizontal);
export default __webpack_public_path__ + "static/media/td-monogram-trail-horizontal.6401310995ec45e637422833d0f5f46c.svg";
export { ForwardRef as ReactComponent };